import { useEffect } from 'react'

import { useDispatch } from 'react-redux'
import { Route, Routes } from 'react-router-dom'

import { fetchStatus } from '@/ducks/resaleReducer'

import Page from '../page/Page'

import Listing from './Listing'
import Listings from './Listings'

import './resale.scss'

const Resale = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    // @ts-ignore
    dispatch(fetchStatus())
  }, [])

  return (
    <Page className="resale">
      <h2 className="text-2xl">Bruktutstyr</h2>

      <Routes>
        <Route path="" element={<Listings />} />
        <Route path="listing/:listingId" element={<Listing />} />
      </Routes>
    </Page>
  )
}

export default Resale
